import R from 'ramda'

const MOSAIC_OPT_OUT_ACTION_TYPE = 'MOSAIC_OPT_OUT'
const MOSAIC_OPT_OUT_DISPLAY_TYPE = 'Mosaic opt out'

const isMosaicOptOutWidgetAction = R.propEq('type', MOSAIC_OPT_OUT_ACTION_TYPE)

const convertMosaicOptOutWidgetActionToFormAction = R.applySpec({
  type: R.always(MOSAIC_OPT_OUT_DISPLAY_TYPE)
})

export {
  isMosaicOptOutWidgetAction,
  convertMosaicOptOutWidgetActionToFormAction
}



// WEBPACK FOOTER //
// ./src/pages/widgets/mapping/actions/twitter/widget-to-form/mosaic-opt-out.js